import { CsiState } from './csi.reducer';

export const enum CSIActionType {
    SetRating = 'CSI/SET_RATING',
    SetLikes = 'CSI/SET_LIKES',
    SetDislikes = 'CSI/SET_DISLIKES',
    SetComment = 'CSI/SET_COMMENT',
    Send = 'CSI/SEND',
    Reset = 'CSI/RESET',
    SetRejected = 'CSI/SET_REJECTED',
    setCsiState = 'CHAT/SET_CSI_STATE',
    SetCSIVisible = 'CHAT/SET_CSI_VISIBLE',
}

export type CSISetRatingAction = ReturnType<typeof csiSetRating>;
export const csiSetRating = (rating: number) => ({
    type: CSIActionType.SetRating,
    payload: rating,
});

export type CSISetLikesAction = ReturnType<typeof csiSetLikes>;
export const csiSetLikes = (likes: string[]) => ({
    type: CSIActionType.SetLikes,
    payload: likes,
});

export type CSISetDislikesAction = ReturnType<typeof csiSetDislikes>;
export const csiSetDislikes = (dislikes: string[]) => ({
    type: CSIActionType.SetDislikes,
    payload: dislikes,
});

export type CSISetCommentAction = ReturnType<typeof csiSetComment>;
export const csiSetComment = (comment: string) => ({
    type: CSIActionType.SetComment,
    payload: comment,
});

export type SetCsiStateAction = ReturnType<typeof setCsiState>;
export const setCsiState = (payload: Partial<CsiState>) => ({
    type: CSIActionType.setCsiState,
    payload,
});

export type CSISetRejectedAction = ReturnType<typeof csiSetRejected>;
export const csiSetRejected = (payload: boolean) => ({
    type: CSIActionType.SetRejected,
    payload,
});

export type SetCSIVisibleAction = ReturnType<typeof setCSIVisible>;
export const setCSIVisible = (payload: boolean) => ({
    type: CSIActionType.SetCSIVisible,
    payload,
});

export type CSISendAction = ReturnType<typeof csiSend>;
export const csiSend = () => ({
    type: CSIActionType.Send,
});

export type CSIResetAction = ReturnType<typeof csiReset>;
export const csiReset = () => ({
    type: CSIActionType.Reset,
});
